<template>
    <div class="flex w-full gap-5 h-full event-type-view justify-content-around overflow-hidden">
        <div class="section-table w-full">
            <div class="flex justify-content-between align-items-center flex-wrap">
                <h2 class="page-header">{{ $t('message.eventType.header') }}</h2>
                <CustomButton :label="$t('message.eventType.addNewButton')" @click="addNewEvent"/>
            </div>
            <EventTypeTable ref="eventTypeTable" v-model="selectedEvent" @showForm="showForm"/>
        </div>
        <LibyanOrnament/>
        <div id="scrollToForm" class="section-details">
            <div class="flex justify-content-between align-items-center pr-1">
                <h2 class="page-header">{{ createMode ? $t('message.eventType.headerNew') : $t('message.eventType.headerEdit') }}</h2>
                <CustomIconButton icon="pi pi-times" onlyIcon @click="hideForm" class="close-form-button" />
            </div>
            <EventTypeForm :selectedEvent="selectedEvent" @change-element="reloadTable"
                           @createMode="(val) => createMode = val" @hideForm="hideForm"/>
        </div>
    </div>
</template>

<script>
import EventTypeTable from "./components/EventTypeTable";
import EventTypeForm from "./components/EventTypeForm";
import CustomButton from "@/components/form/CustomButton.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomIconButton from "@/components/form/CustomIconButton.vue";
import { ShowHideFormUtils } from "@/utils/ShowHideFormUtils";

export default {
    name: "EventTypeListView",
    components: {
        LibyanOrnament,
        EventTypeTable,
        EventTypeForm,
        CustomButton,
        CustomIconButton,
    },
    data() {
        return {
            selectedEvent: {},
            createMode: true,
        }
    },
    mounted() {
        this.selectedEvent = this.getClearEvent();
    },
    methods: {
        getClearEvent() {
            return {
                id: null,
                description: "",
            };
        },
        reloadTable() {
            this.$refs.eventTypeTable.reloadTable();
            this.selectedEvent = this.getClearEvent();
        },
        addNewEvent() {
            ScrollToUtils.scrollToElement();
            this.$refs.eventTypeTable.addNewEvent();
            this.selectedEvent = this.getClearEvent();
            this.showForm();
        },
        showForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details");
        },
        hideForm() {
            ShowHideFormUtils.showHideVertical(".section-table", ".section-details", true);
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/theme/mytheme/variables";
    .event-type-view {
        @media screen and (max-width: 1200px) {
            flex-direction: column;
            align-items: center;
            .section-table, .section-details {
                width: 90% !important;
            }
            .close-form-button {
                display: none;
            }
        }
    }
    .section-table, .section-details {
        transition: 1s ease-in-out;
    }
    .section-details {
        height: calc(100vh - 40px - $top-bar-height);;
        overflow-y: auto;
        width: 0;
    }
</style>
